import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { KindTag } from '../shared/KindTag';
import { Reveal } from '../shared/Reveal';
import { SectionHeading } from '../shared/SectionHeading';
import { ServiceGlyph } from '../shared/ServiceGlyph';
import { useLanguage } from '../../contexts/LanguageContext';
import { serviceMeta } from '../../data/site';
export function ServiceCards() {
  const {
    t
  } = useLanguage();
  return <section aria-labelledby="services-title" className="bg-white py-20 sm:py-24" data-id="element-83" data-mp="28yuq1xmgeemb">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-84" data-mp="23zzzuam5pns6">
        <Reveal data-id="element-85" data-mp="2ir8zlcjrwpj1">
          <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-86" data-mp="2irsc2dqnmlpo">
            <SectionHeading id="services-title" title={t.home.services.title} description={t.home.services.description} data-id="element-87" data-mp="2e00kbzvri9xy" />
            <Link to="/services" className="group inline-flex items-center gap-2 text-sm font-medium text-mauve" data-id="element-88" data-mp="1q9en73naqa2q">
              {t.home.services.viewAll}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-89" data-mp="2py2vmomgt5l5" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-90" data-mp="2txbsw3gprllg">
          {t.services.items.map((service, i) => {
          const meta = serviceMeta.find(m => m.slug === service.slug);
          if (!meta) return null;
          return <Reveal key={service.slug} delay={0.04 * (i % 3)} className="h-full" data-id="element-91" data-mp="270a2ge1n8a0y" data-mpi={i}>
                <article className="flex h-full flex-col" data-id="element-92" data-mp="2b1lknyi6tsz4">
                  <Link to={`/services/${service.slug}`} className="group relative block aspect-[4/3] overflow-hidden rounded-2xl bg-cream" tabIndex={-1} aria-hidden="true" data-id="element-93" data-mp="2fzn5ooz6c2d8">
                    <img src={meta.image} alt="" loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-smooth group-hover:scale-[1.04]" data-id="element-94" data-mp="3rgwnl72nmmcf" />
                    <span className="absolute left-3 top-3 flex gap-2" data-id="element-95" data-mp="31q4yk4e2egds">
                      <KindTag kind={meta.kind} label={t.common.kinds[meta.kind]} data-id="element-96" data-mp="3gmw30s2liia9" />
                      {meta.slug === 'balloon-arches' ? <span className="rounded-full bg-mauve px-2.5 py-1 text-[11px] font-medium text-white" data-id="element-97" data-mp="3bmrjet6e57ft">
                          {t.services.page.newBadge}
                        </span> : null}
                    </span>
                  </Link>
                  <div className="flex flex-1 flex-col pt-5" data-id="element-98" data-mp="2xqmh5ilgcnfp">
                    <ServiceGlyph icon={meta.icon} className="h-6 w-6 text-mauve" data-id="element-99" data-mp="2sxtauqac571i" />
                    <h3 className="mt-3 font-display text-xl font-semibold leading-snug text-ink" data-id="element-100" data-mp="258ijfzevkp01">
                      <Link to={`/services/${service.slug}`} className="hover:text-mauve" data-id="element-101" data-mp="209xgvtc5ht8f">
                        {service.title}
                      </Link>
                    </h3>
                    <p className="mt-2 text-sm leading-relaxed text-ink/70" data-id="element-102" data-mp="fptpih0e9awm">{service.short}</p>
                    <div className="mt-auto flex items-center justify-between border-t border-petal pt-4" data-id="element-103" data-mp="kk6dn4ctfaep">
                      <span className="text-sm font-medium text-mauve-deep" data-id="element-104" data-mp="asjtgiii20zt">{service.price}</span>
                      <Link to={`/services/${service.slug}`} className="group inline-flex items-center gap-1.5 text-sm font-medium text-mauve hover:text-mauve-deep" data-id="element-105" data-mp="yi4po33nyur1">
                        {t.common.learnMore}
                        <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-smooth group-hover:translate-x-1" data-id="element-106" data-mp="pjiwzf4h9zcj" />
                      </Link>
                    </div>
                  </div>
                </article>
              </Reveal>;
        })}
        </div>
      </div>
    </section>;
}